<template>
  <b-card no-body>
    <b-card-body>
      <region-pricing-detail
        ref="regionPricingDetail"
        type="new"
        :submitting="submitting"
        @submit="preview"
      />
    </b-card-body>

    <b-modal
      size="xl"
      id="pricingPreview"
      @close="previewData = null"
      cancel-variant="outline-secondary"
      :ok-title="t('Confirm')"
      :cancel-title="t('Close')"
      centered
      :title="t('Region Pricing Preview')"
      @ok="submit"
    >
      <b-overlay rounded="md" variant="transparent">
        <div class="mb-1 font-bold">
          {{
            $t('You are about to make changes to current prices, please check and confirm prices.')
          }}
        </div>
        <region-pricing-table-view v-if="previewData" :data="previewData" />
      </b-overlay>
    </b-modal>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody, BOverlay } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import RegionPricingDetail from '@/views/pages/providers/RegionPricingDetail.vue';
import RegionPricingTableView from './RegionPricingTableView.vue';

export default {
  components: {
    BCard,
    BCardBody,
    BOverlay,
    RegionPricingDetail,
    RegionPricingTableView
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      data: {},
      previewData: null,
      previewedFormData: null,
      openPreview: false
    };
  },
  methods: {
    preview(data) {
      this.submitting = true;
      useService.providerService
        .previewRegionPricing({ ...data, providerId: this.$route.params.id })
        .then(response => {
          this.previewedFormData = response.data;
          this.previewData = response.data?.preview;

          this.$bvModal.show('pricingPreview');
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submit() {
      if (!this.previewedFormData) return;
      const data = this.previewedFormData;

      this.submitting = true;
      useService.providerService
        .createProviderPricing(data.id)
        .then(response => {
          this.showSuccessMessage(response.message || '');
          this.$refs.regionPricingDetail.resetForm();
          this.$router.push({
            name: 'customer_regions_price_list',
            params: { id: this.$route.params.id }
          });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
